/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
} from './PalReauthCaseManager';

/**
 * 
 * @export
 * @interface FindAllPalReauthCaseManagersResponse
 */
export interface FindAllPalReauthCaseManagersResponse {
    /**
     * 
     * @type {Array<PalReauthCaseManager>}
     * @memberof FindAllPalReauthCaseManagersResponse
     */
    data: Array<PalReauthCaseManager>;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthCaseManagersResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthCaseManagersResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthCaseManagersResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllPalReauthCaseManagersResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllPalReauthCaseManagersResponse interface.
 */
export function instanceOfFindAllPalReauthCaseManagersResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllPalReauthCaseManagersResponseFromJSON(json: any): FindAllPalReauthCaseManagersResponse {
    return FindAllPalReauthCaseManagersResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthCaseManagersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthCaseManagersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalReauthCaseManagerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllPalReauthCaseManagersResponseToJSON(value?: FindAllPalReauthCaseManagersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PalReauthCaseManagerToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

